import React from "react";
import { logOut } from "./firebase";

export default function PendingScreen({ user }) {
  return (
    <div style={{ minHeight:"100vh", background:"#020817", display:"flex", alignItems:"center", justifyContent:"center", fontFamily:"'DM Sans','Segoe UI',sans-serif" }}>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&display=swap" rel="stylesheet"/>
      <div style={{ width:"100%", maxWidth:420, padding:40, background:"#0f172a", border:"1px solid #1e293b", borderRadius:20, textAlign:"center" }}>
        <div style={{ fontSize:40, marginBottom:16 }}>⏳</div>
        <h2 style={{ fontSize:20, fontWeight:700, color:"white", margin:"0 0 10px" }}>Access Pending</h2>
        <p style={{ fontSize:13, color:"#64748b", margin:"0 0 8px", lineHeight:1.6 }}>
          Your account (<strong style={{ color:"#94a3b8" }}>{user?.email}</strong>) is waiting for an administrator to approve your access.
        </p>
        <p style={{ fontSize:13, color:"#64748b", margin:"0 0 28px", lineHeight:1.6 }}>
          Contact <strong style={{ color:"#94a3b8" }}>emajor@dorcushomeva.org</strong> if you need access right away.
        </p>
        <button onClick={logOut} style={{ padding:"10px 24px", background:"#1e293b", border:"1px solid #334155", color:"#94a3b8", borderRadius:8, fontSize:13, cursor:"pointer" }}>
          Sign Out
        </button>
      </div>
    </div>
  );
}
